<template>

  <div class="live-player-wrapper">
    <div class="thumb-image" v-if="webcastStatus!='live'">
      <img :src="webcast.thumbUrl"  class="webcast-image" alt="webcast-image">
      <div class="webcast-timing-wrapper">
        <div class="webcast-timing">
          <div v-if="webcastStatus=='ended'">
            Livecast has ended
          </div>
          <div v-if="webcastStatus=='upcoming'">
            <p>Livecast will start in {{webcast.startAt | moment("from")}}</p>
            <p style="font-size:12px;">{{webcast.startAt | moment("DD.MM.YYYY @HH:mm")}}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="embed-responsive embed-responsive-16by9" v-if="webcastStatus=='live'">
      <div id="player" class="player embed-responsive-item">
        <video
          controls
          height="400"
          width="550"
          class="video-js vjs-default-skin"
          autoplay
          playsinline
        >

        </video>
      </div>
    </div>
    <div class="under-player-bar" v-if="hasStreams || pageSettings.callToActionEnabled">
      <div class="" v-if="pageSettings.callToActionEnabled">
        <Button type="success" :to="pageSettings.callToActionLink" target="_blank" style="float:left; margin-top: 6px; margin-left: 6px;">{{pageSettings.callToActionText}}</Button>
      </div>
      <div class="" v-if="hasStreams">
        <Select v-model="selectedStream" style="width: 100px; position: absolute; right: 10px; margin-top:8px;" placement="bottom-end">
          <Option v-for="s in streams" :value="s._id" :key="s._id">{{ s.name }}</Option>
        </Select>
      </div>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'tiny-cookie';
import {mapState, mapGetters, mapActions} from 'vuex'
import feathersClient from '@/api/feathers-client'
import logger from '@/api/logger'
import loadjs from 'loadjs'

export default {
  data(){
    return {
      player: null,
      selectedStream: null
    }
  },
  computed:{
    ...mapGetters('stream', {
      streamsInStore: 'find',
      getStreamInStore: 'get'
    }),

    ...mapGetters('registrations', {
			registration: 'getCopy',
    }),

    ...mapGetters('session-connections', {
			sessionConnection: 'getCopy',
    }),

    ...mapGetters('page-settings', {
			pageSettings: 'getCopy',
		}),

    ...mapGetters('webcast', {
      webcast: 'getCopy'
    }),

    webcastStatus(){
      //console.log(this.webcast.status);
      return this.webcast.status;
    },
    webcastCurrentSessionId(){
      return this.webcast.currentSessionId;
    },
    streams(){
      return this.streamsInStore().data
    },
    hasStreams(){
      //if(this.webcast.status != 'live') return false;
      if(this.streamsInStore().data.length>1) return true;
      else return false;
    },
    stream(){
      return this.getStreamInStore(this.$data.selectedStream)
    },
    playerUrl(){
      //console.log(this.stream.playerUrl);
      if(this.stream.playerUrl && this.stream.playerUrl != ""){
        return this.stream.playerUrl
      } else {
        //return '//'+this.$store.state.appsettings.copy.playerUrl+'?hlsUrl=//'+this.$store.state.appsettings.copy.hlsUrl+'/'+this.stream.streamId+'/playlist.m3u8'
        return '//'+this.$store.state.appsettings.copy.hlsUrl+'/'+this.stream.streamId+'/playlist.m3u8'
      }
    },
    iframeSrc(){
      return this.playerUrl+'&streamId='+this.stream._id+'&attId='+this.$data.attId+'&sessionId='+this.$store.state.webcast.copy.currentSessionId;
    }
  },
  methods: {
    ...mapActions('session-connections', {
      track: 'track'
    }),
    createPlayer(){
      let self = this;
      if(this.webcast.status=='live'){
        //console.log('live');
        setTimeout(()=>{
          var videoElement = document.getElementsByTagName("video")[0];
          this.$data.player =  window.videojs(videoElement, {
            "viblast": {
                "key": "5539fc37-66df-4808-816d-e63e3faa1bbf",
                "enablePdn": true,
                "enableRealtimeLogger": true,
                "clearkey": {},
                "stream": this.playerUrl
            },
            "width": 640,
            "height": 360,
            'controls': true,
            'autoplay': true,
            'preload': 'auto',
            'fluid': true,
            sources: [{
              src: this.playerUrl,
              type: 'application/x-mpegURL'
            }],
          });

          self.$data.player.ready(function(){
            self.track({eventName:'ready'});
          });
          self.$data.player.on('play',function(){
            self.track({eventName:'play'});
          });
          self.$data.player.on('pause',function(){
            self.track({eventName:'stop'});
          });
          self.$data.player.on('error',function(){
            self.track({eventName:'stop'});
          });
          self.$data.player.on('stop',function(){
            self.track({eventName:'stop'});
          });

          let minutes = 0;
          let interval = setInterval(function(){
            if(self.$data.player){
              self.track({
                eventName:'metrics',
                data: {
                  timers:{
                    watch: self.$data.player.currentTime()*1000
                  }
                }
              });
            }
          }, 15000);
        },100);
      } else{

      }
    },
  },
  watch:{

    webcastStatus(s){
      if(s != "live"){

        if(this.player){
          this.player.pause();
          this.player.dispose();
          this.player = null;
        }
      } else {
        this.createPlayer();
      }
    },
    webcastCurrentSessionId(sid){
      //console.log(sid);
    },
    selectedStream(){
      if(this.player){
        this.player.pause();
        this.player.src(this.playerUrl);
        this.player.play();
      }
    }
  },
  created(){
    let self = this;
    loadjs(['/viblast/video-js.css', '/viblast/video.js', '/viblast/viblast.js'], 'viblast');
    loadjs.ready('viblast', function() {
      if(self.$router.currentRoute.query['streamId']){
        self.$data.selectedStream = self.$router.currentRoute.query['streamId'];
      } else {
        self.$data.selectedStream = self.streamsInStore({query:{$limit:1}}).data[0]._id;
      }
      self.createPlayer();
    });
    //console.log(this.pageSettings);
  },
  destroyed(){
    if(this.player){
      this.player.dispose();
      this.player = null;
    }
  }
}
</script>

<style lang="less">
.live-player-wrapper{
  @media screen and (min-width: 992px) {
      transform: translateY(-50%);
    top: 50%;
    position: relative;
  }
}
.webcast-image {
  width:100%;
  height:auto;
  display: inherit;
}
.webcast-timing-wrapper{
  bottom: 97px;
  position: relative;
  z-index: 10;
  left: 16px;
  width: 320px;
  height: 0px;
}
.webcast-timing{
  background-color: #000;
  padding: 15px;
  border-radius: 4px;
  font-size: 14px;
  color: #fff;
}
.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}
.embed-responsive::before {
    display: block;
    content: "";
}
.embed-responsive .embed-responsive-item, .embed-responsive embed, .embed-responsive iframe, .embed-responsive object, .embed-responsive video {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
}
.embed-responsive-16by9::before {
  padding-top: 56.25%;
}
#player .container{
  max-width: 100% !important;
}
.under-player-bar{
  height: 48px;
  position: relative;
  @media screen and (max-width: 992px) {
    position: relative;
    width: 100%;
    background-color: #000;
    overflow: visible;
  }

  .ivu-select-selection{
    background-color: #000;
    color: #fff;
  }

  .ivu-select-dropdown{
    background-color: rgb(0, 0, 0);
    color: rgb(255, 255, 255);
  }

  .ivu-select-item-focus {
      background: #222;
  }

  .ivu-select-item{
    color: #ccc;
  }

  .ivu-select-item:hover {
    background: #444;
  }

}

</style>
